const Tabs = ({ t, setTab, tab }) => {
  const tabs = [
    {
      name: t("profile"),
      value: "profile",
    },
    {
      name: t("jopInfo"),
      value: "jopInfo",
    },
    {
      name: t("salaryAndContract"),
      value: "contract",
    },
    {
      name: t("attendanceAndVacations"),
      value: "attendance",
    },
    {
      name: t("prevRequests"),
      value: "requests",
    },
    {
      name: t("docs"),
      value: "docs",
    },
  ];
  return (
    <section className="grid grid-cols-1 my-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
      {tabs.map((t, i) => {
        const active = t.value === tab;

        return (
          <button
            className={`bg-[#182443] border-b text-center py-4 font-semibold ${
              active ? "text-white border-white" : "text-primary border-transparent"
            }`}
            onClick={() => setTab(t.value)}
            key={i}
          >
            {t.name}
          </button>
        );
      })}
    </section>
  );
};

export default Tabs;
